import { gql } from '../__generated__/gql';

const SEARCH_USERS = gql(`
  query SearchUsers(
    $orderBy: [UserOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: UserWhereInput
  ) {
    users(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      name
    }
  }
`);

export default SEARCH_USERS;
